export default __webpack_public_path__ + "static/media/csango10-elado-lakasok.07c916cb.webp";